module.exports = __webpack_public_path__ + "static/media/angle-left.86c9a98a.svg";